import styled from "styled-components";
import { COLORS } from "../../styles/constants.style";

export const MuiDoubleLabelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  .label-style {
    line-height: 22px;
    color: ${COLORS.cirrus_black};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .value-style {
    line-height: 20px;
    color: ${COLORS.cirrus_black};
  }
`;
